import { checkRegex } from '@/utils/checkRegex';

export default function isAlphanumeric(string) {
  return checkRegex(/^[a-zA-Z0-9]*$/, string);
}